export class PDFUserFacingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "PDFUserFacingError";
  }
}

export class ElevationAnnotationPlacementError extends PDFUserFacingError {
  constructor(message: string) {
    super(message);
    this.name = "ElevationAnnotationPlacementError";
  }
}

const ElevationAnnotationPlacementErrorMessagePrefix = "elevation view note placement failed:";

export function elevationAnnotationPlacementErrorDetail(message: string): string {
  if (!isElevationAnnotationPlacementErrorMessage(message)) {
    return message;
  }
  return message.slice(ElevationAnnotationPlacementErrorMessagePrefix.length).trim();
}

export function isPDFUserFacingError(error: unknown): boolean {
  return (
    error instanceof PDFUserFacingError ||
    (error instanceof Error &&
      (error.name === "PDFUserFacingError" || error.name === "ElevationAnnotationPlacementError"))
  );
}

export function isElevationAnnotationPlacementError(error: unknown): boolean {
  return (
    error instanceof ElevationAnnotationPlacementError ||
    (error instanceof Error && error.name === "ElevationAnnotationPlacementError")
  );
}

export function isElevationAnnotationPlacementErrorMessage(message: string): boolean {
  return message.startsWith(ElevationAnnotationPlacementErrorMessagePrefix);
}
